import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "@/common/directives/when";
import styles from "@/index.css?inline";
import EkoElement from "@/utilities/element";
import style from "./breadcrumb.css?inline";

@customElement("eko-breadcrumb")
export class Breadcrumb extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(styles), unsafeCSS(style)];

  @property({ reflect: true })
  href?: string;

  render() {
    return html`
      <li class="eko-breadcrumb">
        <a class="eko-breadcrumb-link" href=${when(this.href)}>
          <slot></slot>
        </a>
        <eko-icon
          name="chevron-right"
          class="eko-breadcrumbs-separator"
          size="sm"
          aria-hidden="true"></eko-icon>
      </li>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-breadcrumb": Breadcrumb;
  }
}

export default Breadcrumb;
